/* CAINTÈ product page v2 – runs right after vendor.min.js (which brings its own jQuery + slick) and
   before theme.min.js. Wraps $.fn.slick so the product gallery is always initialised as ONE slide
   with fade on desktop; theme.min.js asks for two slides side by side on carousel layouts. */
(function () {
  if (!window.jQuery) return;
  var $ = window.jQuery;
  function wrap(orig) {
    if (!orig || orig.__pdpv2) return orig;
    var w = function () {
      var args = Array.prototype.slice.call(arguments);
      if (args.length && args[0] && typeof args[0] === 'object' && this.is && this.is('.product-slideshow') && window.matchMedia('(min-width: 1041px)').matches) {
        args[0] = $.extend({}, args[0], { slidesToShow: 1, slidesToScroll: 1, fade: true });
      }
      return orig.apply(this, args);
    };
    w.__pdpv2 = true;
    return w;
  }
  var current = wrap($.fn.slick);
  try {
    Object.defineProperty($.fn, 'slick', {
      configurable: true,
      enumerable: true,
      get: function () { return current; },
      set: function (fn) { current = wrap(fn); }
    });
  } catch (e) {
    if (current) $.fn.slick = current;
  }
})();
